import { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { HomeCasino, LiveCasino, Slots } from "../Pages/casino/CasinoList";
import referenceArtwork from "../Pages/referenceArtwork.json";

const START = 782525050;
const ART = new Map(referenceArtwork.map((item) => [item.name, item.img]));
const WINS = [
  { name: "Wild Bounty Showdown", mask: "*******162", amount: "28,422" },
  { name: "Aviator", mask: "******321", amount: "25,700" },
  { name: "Mahjong Win", mask: "****laz", amount: "10,320" },
  { name: "Crazy Time", mask: "****r11", amount: "6,300" },
  { name: "Mega Wheel", mask: "****234", amount: "6,675" },
  { name: "Crazy Time A", mask: "******can", amount: "4,010" },
  { name: "Super Ace", mask: "****882", amount: "128,450" },
  { name: "Boxing King", mask: "****908", amount: "54,610" },
  { name: "Money Coming", mask: "****312", amount: "210,775" },
  { name: "Fortune Gems", mask: "****441", amount: "96,220" },
  { name: "Super Ace Deluxe", mask: "****650", amount: "88,040" },
  { name: "Fortune Gems 3", mask: "****019", amount: "143,900" },
];

const findGame = (name) =>
  HomeCasino.HotGame.find((game) => game.name === name) ||
  LiveCasino.find((game) => game.name === name) ||
  Slots.find((game) => game.name === name);

export default function ReferenceJackpot({ lang }) {
  const [amount, setAmount] = useState(START);
  const launchCasino = useContextSelector(AuthContext, (ctx) => ctx.launchCasino);
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const setLoginModal = useContextSelector(AuthContext, (ctx) => ctx.setLoginModal);
  const digits = String(amount).padStart(9, "0").slice(-9).split("");
  const wonLabel = lang === "en" ? "Just won in" : "জিতেছে";
  const cards = WINS.map((win) => {
    const game = findGame(win.name);
    return game ? { ...win, game, img: ART.get(win.name) || game.img } : null;
  }).filter(Boolean);

  useEffect(() => {
    const timer = setInterval(() => {
      setAmount((current) => current + 1 + Math.floor(Math.random() * 12));
    }, 800);
    return () => clearInterval(timer);
  }, []);

  const openGame = (game) => {
    if (isEmpty(user)) {
      setLoginModal(true);
      return;
    }
    if (isEmpty(game?.platFormCode)) {
      toast.error("Coming Soon");
      return;
    }
    launchCasino({
      platForm: game.platFormCode,
      gameType: game.gameType,
      casinoType: game.casinoType,
    });
  };

  return (
    <section className="ref-jackpot" aria-label="Jackpot">
      <div className="ref-jackpot-digits" aria-label={digits.join("")}>
        {digits.map((digit, index) => (
          <span key={index} className="ref-digit-slot">
            {(index === 3 || index === 6) && <span className="ref-digit-separator">,</span>}
            <span className="ref-digit">
              <span className="ref-digit-reel" style={{ transform: `translateY(-${Number(digit) * 10}%)` }}>
                {Array.from({ length: 10 }, (_, value) => <span key={value}>{value}</span>)}
              </span>
            </span>
          </span>
        ))}
      </div>
      <div className="ref-featured-games">
        <div className="ref-win-track">
          {[0, 1].map((copy) => (
            <div className="ref-win-set" key={copy} aria-hidden={copy === 1 || undefined}>
              {cards.map((win) => (
                <button key={`${copy}-${win.name}`} type="button" className="ref-win-card" onClick={() => openGame(win.game)}>
                  <span className="ref-win-thumb">
                    <img src={win.img} alt="" />
                    <span className="ref-win-play">PLAY NOW</span>
                  </span>
                  <span className="ref-win-copy">
                    <strong>{win.game.name}</strong>
                    <span className="ref-win-user">{win.mask} {wonLabel}</span>
                    <span className="ref-win-amount">৳ {win.amount}</span>
                  </span>
                </button>
              ))}
            </div>
          ))}
        </div>
      </div>
      <img className="ref-jackpot-chrome" src="/assets/bdtwin/jackpot-bg.png" alt="" draggable={false} />
    </section>
  );
}
